'use strict';

var _ = require('lodash');
var FaresOptimizerDetailsToolbarFilterService = function FaresOptimizerDetailsToolbarFilterService() {
  function getMinStayGroupFilter(contextData) {
    return getDropDownValueForLabel('minStays', contextData, 'Min Stay');
  }
  function getMaxStayGroupFilter(contextData) {
    return getDropDownValueForLabel('maxStay', contextData, 'Max Stay');
  }
  function getDowFilter(contextData) {
    return getDropDownValueForLabel('dow', contextData, 'DOW');
  }
  function getAdvPurchaseGroupFilter(contextData) {
    return getDropDownValueForLabel('apGroup', contextData, 'AP');
  }
  function fetchLabelBasedDataFromContext(label, contextData) {
    if (label === 'apGroup') {
      return contextData.apGroup;
    } else if (label === 'maxStay') {
      return contextData.maxStay;
    } else if (label === 'minStays') {
      return contextData.minStays;
    } else if (label === 'dow') {
      return contextData.dow;
    }
  }
  function mapGroupsToDropdown(groups, startKey, endKey) {
    return _.map(groups, function (group) {
      return mapToDropdown(formatGroup(group, startKey, endKey));
    });
  }
  function formatGroup(group, startKey, endKey) {
    return (group[startKey] === '' && group[endKey] === '') === true ? '-' : group[startKey] + ' - ' + group[endKey];
  }
  function mapToDropdown(item) {
    return {
      value: item,
      dropdownVisibleValue: item
    };
  }
  function mapDow(item) {
    return {
      value: _.chain(item).replace(' ', '').value(),
      label: item
    };
  }
  function getDropDownValueForLabel(label, contextData, filterTitle) {
    var noneGroupFlag = false;
    var groups;
    if (label === 'dow' || label === 'minStays' || label === 'maxStay') {
      groups = _.chain(contextData).map(function (cData) {
        return fetchLabelBasedDataFromContext(label, cData);
      }).map(function (val) {
        return val === undefined || val === '' || val === null ? 'Nil' : val;
      }).uniq().value();
    } else {
      groups = _.chain(contextData).map(function (cData) {
        return fetchLabelBasedDataFromContext(label, cData);
      }).uniq().filter(function (udata) {
        var filterResult = filterData(udata);
        if (filterResult === false) {
          noneGroupFlag = true;
        }
        return filterResult;
      }).map(function (udata) {
        var splitData = _.split(udata, '-');
        if (splitData.length > 1) {
          return {
            startRange: splitData[0].trim(),
            endRange: splitData[1].trim()
          };
        }
      }).value();
    }
    var options;
    if (label === 'dow' || label === 'minStays' || label === 'maxStay') {
      options = _.map(groups, mapDow);
    } else {
      options = noneGroupFlag === false ? _.concat(mapGroupsToDropdown(groups, 'startRange', 'endRange')) : _.concat([mapToDropdown('None')], mapGroupsToDropdown(groups, 'startRange', 'endRange'));
    }
    return {
      filterId: label,
      title: filterTitle,
      type: 'combobox',
      options: options
    };
  }
  function filterData(data) {
    return _.split(data, '-').length > 1 ? true : false;
  }
  function loadFiltersFromContextData(contextData) {
    return _.concat([], getAdvPurchaseGroupFilter(contextData.fareLaddersInGroup), getMinStayGroupFilter(contextData.fareLaddersInGroup), getMaxStayGroupFilter(contextData.fareLaddersInGroup), getDowFilter(contextData.fareLaddersInGroup));
  }
  return {
    loadFiltersFromContextData: loadFiltersFromContextData
  };
};
FaresOptimizerDetailsToolbarFilterService.$inject = [];
module.exports = FaresOptimizerDetailsToolbarFilterService;